import * as React from "react";
import useStyles from "./TabGeneralInquiry.styles";
import { useEffect, useState } from "react";
import AppTitle from "../AppTitle";
import { CircularProgress, Grid, useMediaQuery } from "@mui/material";
import AppTextField from "../AppTextField";
import AppCheckBox from "../AppCheckBox";
import AppButton from "../AppButton";
import { feedbackApi } from "@/utils/api";
import theme from "@/assets/theme";
import { useTranslation } from "next-i18next";
import { DICTIONARY } from "@/utils/constants/translation.constant";
import { capitalize } from "lodash";
import ReCAPTCHA from "react-google-recaptcha";
import { capitalizeFirstLetterAllWords } from "@/utils/helpers/common";
import { IDescriptionForFeedbackResponse } from "@/utils/api/feedback/feedback.api.types";
import { useIsMounted } from "usehooks-ts";

type TabGeneralInquiryProps = {};

const TabGeneralInquiry = (props: TabGeneralInquiryProps) => {
  const { t, i18n } = useTranslation();
  // const { locale } = useRouter();
  const locale = i18n.language;
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const { classes } = useStyles({ params: { locale: locale! } });
  const [lastName, setLastName] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [content, setContent] = useState<string>("");
  const [accept, setAccept] = useState<boolean>(false);
  const [emailValidated, setEmailValidated] = useState<boolean>(false);
  const [isDisable, setIsDisable] = useState<boolean>(false);
  const [captcha, setCaptcha] = useState<boolean>(false);
  const [DescriptionForFeedback, setDescriptionForFeedback] =
    useState<IDescriptionForFeedbackResponse | null>(null);

  let handleLastNameChanges = (e: any) => {
    setLastName(e.target.value);
  };

  let handleFirstNameChanges = (e: any) => {
    setFirstName(e.target.value);
  };

  let handleEmailChanges = (e: any) => {
    setEmail(e.target.value);
    setEmailValidated(
      e.target.value.length === 0 ||
        !e.target.value.includes("@") ||
        !e.target.value.includes(".")
    );
  };

  let handleContentChanges = (e: any) => {
    setContent(e.target.value);
  };

  let handleCheckboxChange = (e: any) => {
    setAccept(e.target.checked);
  };

  let isValid = () => {
    return (
      lastName.length > 0 &&
      firstName.length > 0 &&
      email.length > 0 &&
      email.includes("@") &&
      content.length > 0 &&
      accept
    );
  };

  let onSubmit = async () => {
    if (isValid() && captcha) {
      setIsDisable(true);
      await sendFeedback();
      setIsDisable(false);
    } else {
      alert("Invalid value!");
    }
  };

  let sendFeedback = async () => {
    try {
      let res = await feedbackApi.sendFeedback({
        params: {
          first_name: firstName,
          last_name: lastName,
          email: email,
          content: content,
        },
      });
      alert(res.data.message);
    } catch (error) {
      console.log(error);
    }
  };
  let getDescriptionForFeedback = async () => {
    try {
      let res = await feedbackApi.getDescriptionForFeedback({
        params: {
          type: "GENERAL_INQUIRY",
        },
      });
      if (res.status === 200) {
        setDescriptionForFeedback(res.data.params);
      }
    } catch (error) {
      console.log(error);
    }
  };

  let FetchData = async () => {
    await getDescriptionForFeedback();
  };
  useEffect(() => {
    FetchData();
  }, []);
  useEffect(() => {
    if (!isMounted()) return;
    FetchData();
  }, [locale]);
  const onChange = (value: any) => {
    setCaptcha(true);
  };

  const isMounted = useIsMounted();

  return (
    <div className={classes.contentContainer}>
      <AppTitle
        title={t(DICTIONARY.GENERAL_INQUIRY)}
        color="#4B2884"
        styleTitle={isMobile ? { padding: "24px 0" } : { padding: "50px 0" }}
      />

      <p
        className={classes.instruction}
        dangerouslySetInnerHTML={{
          __html: DescriptionForFeedback?.description
            ? DescriptionForFeedback.description
            : "",
        }}
      />
      <div className={classes.formContainer}>
        <Grid container spacing={"30px"}>
          <Grid item xs={12} md={6}>
            <AppTextField
              required
              label={capitalizeFirstLetterAllWords(t(DICTIONARY.LAST_NAME))}
              id="inputLastName"
              width="100%"
              onChange={handleLastNameChanges}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <AppTextField
              required
              label={capitalizeFirstLetterAllWords(t(DICTIONARY.FIRST_NAME))}
              id="inputFirstName"
              width="100%"
              onChange={handleFirstNameChanges}
            />
          </Grid>
          <Grid item xs={12}>
            <AppTextField
              required
              label={t(DICTIONARY.EMAIL)}
              id="inputEmail"
              width="100%"
              onChange={handleEmailChanges}
              error={emailValidated}
            />
          </Grid>
          <Grid item xs={12}>
            <AppTextField
              required
              label={t(DICTIONARY.CONTENT)}
              id="inputContactUsContent"
              width="100%"
              height="230px"
              multiline
              rows={10}
              onChange={handleContentChanges}
            />
          </Grid>
        </Grid>
        <AppCheckBox
          label={t(DICTIONARY.CONTACT_US_FORM_CONFIRM)}
          sx={{ marginTop: "30px" }}
          onChange={handleCheckboxChange}
        />
        <ReCAPTCHA
          sitekey="6LchqRkpAAAAAPFm1QBCi8_lcKb3-13D2zdcWaeZ"
          onChange={onChange}
        />
        <AppButton
          variant="contained"
          width="290px"
          height="50px"
          sx={{ marginTop: "30px" }}
          onClick={onSubmit}
          disabled={isDisable}
        >
          {isDisable ? (
            <CircularProgress size={20} sx={{ marginRight: 1 }} />
          ) : null}
          <p>{capitalize(t(DICTIONARY.SUBMIT))}</p>
        </AppButton>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "100px",
          }}
        ></div>
      </div>
    </div>
  );
};

export default React.forwardRef(TabGeneralInquiry);
